import { parsePlaylist } from './hlsDecrypt.js';

/**
 * Fichiers médias tels que conservés par le serveur (segments chiffrés et
 * playlist), sans transformation : ce sont eux dont le registre de preuve
 * contient l'empreinte (MEDIA_SEGMENT / MEDIA_PLAYLIST). La copie déchiffrée
 * (.ts) et le MP4 n'en sont que des dérivés de lecture.
 */
export async function downloadHlsOriginals({ playlistUrl, headers = {}, folder = 'medias/originaux', onProgress = () => {} }) {
    const playlistResponse = await fetch(playlistUrl, { headers });
    if (!playlistResponse.ok) throw new Error(`Playlist indisponible (${playlistResponse.status})`);
    const playlist = await playlistResponse.text();
    const segments = parsePlaylist(playlist, playlistUrl);
    const nameOf = url => decodeURIComponent(new URL(url).pathname.split('/').pop());
    const files = [{
        path: `${folder}/playlist.m3u8`,
        content: playlist,
        description: 'Playlist servie par le serveur (adresses réécrites vers l’API : non comparable à l’empreinte du registre)',
    }];
    for (const [index, segment] of segments.entries()) {
        onProgress(`segment d’origine ${index + 1}/${segments.length}`);
        const response = await fetch(segment.url, { headers });
        if (!response.ok) throw new Error(`Segment indisponible (${response.status})`);
        files.push({
            path: `${folder}/${nameOf(segment.url)}`,
            content: new Uint8Array(await response.arrayBuffer()),
            description: 'Segment chiffré d’origine (AES-128-CBC), comparable à l’empreinte du registre',
        });
    }
    return files;
}
